<template>
  <section id="simplify" class="py-[50px] text-[white]">
    <div
      class="content md:flex justify-between items-center max-md:text-center"
    >
      <h2
        class="md:w-[600px] text-[3rem] font-[600] max-md:text-[2.85rem] max-md:mb-[20px]"
      >
        Simplify how your team works today.
      </h2>
      <button class="btn-style bg-[white]">Get Started</button>
    </div>
  </section>
</template>

<style lang="scss" scoped>
#simplify {
  background: $orange url("../assets/images/bg-simplify-section-desktop.svg");

  button {
    color: $orange;
    box-shadow: 0 5px 10px rgba(255, 255, 255, 0.377);

    &:hover {
      background: white;
      color: $orange;
      opacity: 0.9;
    }
  }
}
</style>
